import { Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { history } from '../../../helpers/history';
import { useTranslation } from "../../../commons/useTranslasion";
import { esES, ptBR } from "@mui/material/locale";

const ProgramaPPC: React.FC = () => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const handleChangeTipoLink = () => {
    history.push('/minha-transicao/programa/ppc');
  };

  return (
    <Typography>
      <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
        <Typography sx={{ padding: "10px" }} variant="caption">
          {translate('ppcText1')}
          <br /><br />

          {translate('ppcText2')}
          <br /><br />

          {translate('ppcText3')}
          <br /><br />

          {translate('ppcText4')}
          <br /><br />

          {translate('ppcText5')}
          <br /><br />

          <Grid onClick={handleChangeTipoLink}>
            <Link to="/minha-transicao/programa/ppc">{translate('cliqueAquiParaPreencherOFormulario')}</Link>
            {translate('etapaConcluida')}
          </Grid>
        </Typography>
      </Grid>
    </Typography>
  )
}

export default ProgramaPPC;
